 export interface DailyHadith {
   day: number;
   arabic: string;
   transliteration: string;
   translation: string;
   source: string;
   theme: 'mercy' | 'forgiveness' | 'salvation';
 }
 
 export const dailyHadiths: DailyHadith[] = [
   // Days 1-10: Mercy
   {
     day: 1,
     arabic: "الرَّاحِمُونَ يَرْحَمُهُمُ الرَّحْمَنُ",
     transliteration: "Ar-rahimuna yarhamuhum ar-Rahman",
     translation: "The merciful will be shown mercy by the Most Merciful.",
     source: "Sunan At-Tirmidhi 1924",
     theme: 'mercy'
   },
   {
     day: 2,
     arabic: "مَنْ لَا يَرْحَمْ لَا يُرْحَمْ",
     transliteration: "Man la yarham la yurham",
     translation: "Whoever does not show mercy will not be shown mercy.",
     source: "Sahih Bukhari 5997",
     theme: 'mercy'
   },
   {
     day: 3,
     arabic: "إِنَّ اللَّهَ رَفِيقٌ يُحِبُّ الرِّفْقَ فِي الْأَمْرِ كُلِّهِ",
     transliteration: "Innallaha rafeequn yuhibbur-rifqa fil-amri kullihi",
     translation: "Allah is gentle and loves gentleness in all matters.",
     source: "Sahih Bukhari 6927",
     theme: 'mercy'
   },
   {
     day: 4,
     arabic: "ارْحَمُوا مَنْ فِي الْأَرْضِ يَرْحَمْكُمْ مَنْ فِي السَّمَاءِ",
     transliteration: "Irhamoo man fil-ard yarhamkum man fis-sama",
     translation: "Show mercy to those on earth, and the One in heaven will show mercy to you.",
     source: "Sunan At-Tirmidhi 1924",
     theme: 'mercy'
   },
   {
     day: 5,
     arabic: "إِنَّ لِلَّهِ مِائَةَ رَحْمَةٍ أَنْزَلَ مِنْهَا رَحْمَةً وَاحِدَةً",
     transliteration: "Inna lillahi mi'ata rahma, anzala minha rahmatan wahida",
     translation: "Allah has one hundred parts of mercy, of which He sent down only one part.",
     source: "Sahih Muslim 2752",
     theme: 'mercy'
   },
   {
     day: 6,
     arabic: "مَا مِنْ مُسْلِمٍ يَعُودُ مُسْلِمًا غُدْوَةً إِلَّا صَلَّى عَلَيْهِ سَبْعُونَ أَلْفَ مَلَكٍ",
     transliteration: "Ma min muslimin ya'udu musliman ghudwatan illa salla alayhi sab'una alfa malak",
     translation: "No Muslim visits another Muslim in the morning except that seventy thousand angels pray for him.",
     source: "Sunan At-Tirmidhi 969",
     theme: 'mercy'
   },
   {
     day: 7,
     arabic: "وَاللَّهُ فِي عَوْنِ الْعَبْدِ مَا كَانَ الْعَبْدُ فِي عَوْنِ أَخِيهِ",
     transliteration: "Wallahu fi 'awnil-'abdi ma kanal-'abdu fi 'awni akhihi",
     translation: "Allah helps His servant as long as the servant helps his brother.",
     source: "Sahih Muslim 2699",
     theme: 'mercy'
   },
   {
     day: 8,
     arabic: "إِنَّ اللَّهَ لَا يَنْظُرُ إِلَى صُوَرِكُمْ وَأَمْوَالِكُمْ وَلَكِنْ يَنْظُرُ إِلَى قُلُوبِكُمْ",
     transliteration: "Innallaha la yanzuru ila suwarikum wa amwalikum walakin yanzuru ila quloobikum",
     translation: "Allah does not look at your appearance or wealth, but rather He looks at your hearts.",
     source: "Sahih Muslim 2564",
     theme: 'mercy'
   },
   {
     day: 9,
     arabic: "مَنْ نَفَّسَ عَنْ مُؤْمِنٍ كُرْبَةً نَفَّسَ اللَّهُ عَنْهُ كُرْبَةً مِنْ كُرَبِ يَوْمِ الْقِيَامَةِ",
     transliteration: "Man naffasa 'an mu'minin kurbatan naffasallahu 'anhu kurbatan min kurabi yawmil-qiyamah",
     translation: "Whoever relieves a believer's distress, Allah will relieve his distress on the Day of Resurrection.",
     source: "Sahih Muslim 2699",
     theme: 'mercy'
   },
   {
     day: 10,
     arabic: "تَبَسُّمُكَ فِي وَجْهِ أَخِيكَ لَكَ صَدَقَةٌ",
     transliteration: "Tabasumuka fi wajhi akhika laka sadaqah",
     translation: "Your smile to your brother is charity.",
     source: "Sunan At-Tirmidhi 1956",
     theme: 'mercy'
   },
   // Days 11-20: Forgiveness
   {
     day: 11,
     arabic: "كُلُّ ابْنِ آدَمَ خَطَّاءٌ وَخَيْرُ الْخَطَّائِينَ التَّوَّابُونَ",
     transliteration: "Kullu bni Adama khatta'un wa khayrul-khatta'een at-tawwabun",
     translation: "Every son of Adam sins, and the best of sinners are those who repent.",
     source: "Sunan At-Tirmidhi 2499",
     theme: 'forgiveness'
   },
   {
     day: 12,
     arabic: "إِنَّ اللَّهَ يَبْسُطُ يَدَهُ بِاللَّيْلِ لِيَتُوبَ مُسِيءُ النَّهَارِ",
     transliteration: "Innallaha yabsutu yadahu bil-layli liyatuba musee'un-nahar",
     translation: "Allah extends His hand at night so that those who sinned during the day may repent.",
     source: "Sahih Muslim 2759",
     theme: 'forgiveness'
   },
   {
     day: 13,
     arabic: "التَّائِبُ مِنَ الذَّنْبِ كَمَنْ لَا ذَنْبَ لَهُ",
     transliteration: "At-ta'ibu minadh-dhanbi kaman la dhamba lah",
     translation: "The one who repents from sin is like one who has no sin.",
     source: "Sunan Ibn Majah 4250",
     theme: 'forgiveness'
   },
   {
     day: 14,
     arabic: "قَالَ اللَّهُ تَعَالَى: أَنَا عِنْدَ ظَنِّ عَبْدِي بِي",
     transliteration: "Qalallahu ta'ala: Ana 'inda zanni 'abdi bi",
     translation: "Allah said: I am as My servant expects Me to be.",
     source: "Sahih Bukhari 7405",
     theme: 'forgiveness'
   },
   {
     day: 15,
     arabic: "مَنِ اسْتَغْفَرَ لِلْمُؤْمِنِينَ وَالْمُؤْمِنَاتِ كَتَبَ اللَّهُ لَهُ بِكُلِّ مُؤْمِنٍ حَسَنَةً",
     transliteration: "Manistagh-fara lil-mu'mineena wal-mu'minati kataballahu lahu bikulli mu'minin hasanah",
     translation: "Whoever seeks forgiveness for believing men and women, Allah writes for him a good deed for each believer.",
     source: "At-Tabarani",
     theme: 'forgiveness'
   },
   {
     day: 16,
     arabic: "إِذَا أَذْنَبَ عَبْدٌ ذَنْبًا فَقَالَ: رَبِّ أَذْنَبْتُ فَاغْفِرْ لِي، غَفَرَ لَهُ",
     transliteration: "Idha adhnaba 'abdun dhanban faqala: Rabbi adhanbtu faghfirli, ghafara lahu",
     translation: "When a servant commits a sin and says: 'My Lord, I have sinned, forgive me,' He forgives him.",
     source: "Sahih Bukhari 7507",
     theme: 'forgiveness'
   },
   {
     day: 17,
     arabic: "مَنْ قَالَ أَسْتَغْفِرُ اللَّهَ الَّذِي لَا إِلَهَ إِلَّا هُوَ الْحَيُّ الْقَيُّومُ وَأَتُوبُ إِلَيْهِ غُفِرَتْ ذُنُوبُهُ",
     transliteration: "Man qala Astaghfirullaha-lladhi la ilaha illa huwal-hayyul-qayyum wa atubu ilayhi, ghufirat dhunubuh",
     translation: "Whoever says: 'I seek forgiveness of Allah, the Ever-Living, the Sustainer, and I repent to Him,' his sins will be forgiven.",
     source: "Sunan Abu Dawud 1517",
     theme: 'forgiveness'
   },
   {
     day: 18,
     arabic: "يَقُولُ اللَّهُ تَعَالَى: يَا ابْنَ آدَمَ إِنَّكَ مَا دَعَوْتَنِي وَرَجَوْتَنِي غَفَرْتُ لَكَ",
     transliteration: "Yaqulullahu ta'ala: Ya bna Adam innaka ma da'awtani wa rajawtani ghafartu laka",
     translation: "Allah says: 'O son of Adam, as long as you call upon Me and hope in Me, I will forgive you.'",
     source: "Sunan At-Tirmidhi 3540",
     theme: 'forgiveness'
   },
   {
     day: 19,
     arabic: "مَنْ تَابَ قَبْلَ أَنْ تَطْلُعَ الشَّمْسُ مِنْ مَغْرِبِهَا تَابَ اللَّهُ عَلَيْهِ",
     transliteration: "Man taba qabla an tatlu'ash-shamsu min maghribiha taballahu 'alayh",
     translation: "Whoever repents before the sun rises from the west, Allah will accept his repentance.",
     source: "Sahih Muslim 2703",
     theme: 'forgiveness'
   },
   {
     day: 20,
     arabic: "لَوْ لَمْ تُذْنِبُوا لَذَهَبَ اللَّهُ بِكُمْ وَلَجَاءَ بِقَوْمٍ يُذْنِبُونَ فَيَسْتَغْفِرُونَ فَيُغْفَرُ لَهُمْ",
     transliteration: "Law lam tudhnibu ladhababallahu bikum walaja'a biqawmin yudhniboona fayastaghfiroona fayughfaru lahum",
     translation: "If you did not sin, Allah would replace you with people who sin and seek forgiveness, and He would forgive them.",
     source: "Sahih Muslim 2749",
     theme: 'forgiveness'
   },
   // Days 21-30: Salvation
   {
     day: 21,
     arabic: "مَنْ خَافَ أَدْلَجَ وَمَنْ أَدْلَجَ بَلَغَ الْمَنْزِلَ",
     transliteration: "Man khafa adlaja wa man adlaja balaghal-manzil",
     translation: "Whoever fears (Allah) will travel by night, and whoever travels by night will reach the destination.",
     source: "Sunan At-Tirmidhi 2450",
     theme: 'salvation'
   },
   {
     day: 22,
     arabic: "مَنْ كَانَ آخِرُ كَلَامِهِ لَا إِلَهَ إِلَّا اللَّهُ دَخَلَ الْجَنَّةَ",
     transliteration: "Man kana akhiru kalamihi la ilaha illallah dakhalal-jannah",
     translation: "Whoever's last words are 'There is no god but Allah' will enter Paradise.",
     source: "Sunan Abu Dawud 3116",
     theme: 'salvation'
   },
   {
     day: 23,
     arabic: "إِنَّ فِي الْجَنَّةِ بَابًا يُقَالُ لَهُ الرَّيَّانُ يَدْخُلُ مِنْهُ الصَّائِمُونَ",
     transliteration: "Inna fil-jannati baban yuqalu lahur-Rayyan yadkhulu minhus-sa'imun",
     translation: "In Paradise there is a gate called Ar-Rayyan through which the fasting people will enter.",
     source: "Sahih Bukhari 1896",
     theme: 'salvation'
   },
   {
     day: 24,
     arabic: "مَنْ قَامَ لَيْلَةَ الْقَدْرِ إِيمَانًا وَاحْتِسَابًا غُفِرَ لَهُ مَا تَقَدَّمَ مِنْ ذَنْبِهِ",
     transliteration: "Man qama laylatal-qadri imanan wahtisaban ghufira lahu ma taqaddama min dhanbih",
     translation: "Whoever stands in prayer on Laylatul Qadr with faith and seeking reward, his past sins will be forgiven.",
     source: "Sahih Bukhari 1901",
     theme: 'salvation'
   },
   {
     day: 25,
     arabic: "اتَّقُوا النَّارَ وَلَوْ بِشِقِّ تَمْرَةٍ",
     transliteration: "Ittaqun-nara walaw bishiqqi tamrah",
     translation: "Protect yourselves from the Fire, even if with half a date.",
     source: "Sahih Bukhari 1417",
     theme: 'salvation'
   },
   {
     day: 26,
     arabic: "إِذَا دَخَلَ شَهْرُ رَمَضَانَ فُتِّحَتْ أَبْوَابُ الْجَنَّةِ وَغُلِّقَتْ أَبْوَابُ النَّارِ",
     transliteration: "Idha dakhala shahru ramadana futtihat abwabul-jannati wa ghulliqat abwabun-nar",
     translation: "When Ramadan begins, the gates of Paradise are opened and the gates of Hell are closed.",
     source: "Sahih Bukhari 1899",
     theme: 'salvation'
   },
   {
     day: 27,
     arabic: "لَيْلَةُ الْقَدْرِ خَيْرٌ مِنْ أَلْفِ شَهْرٍ",
     transliteration: "Laylatul-qadri khayrun min alfi shahr",
     translation: "The Night of Decree is better than a thousand months.",
     source: "Quran 97:3",
     theme: 'salvation'
   },
   {
     day: 28,
     arabic: "مَنْ صَامَ رَمَضَانَ إِيمَانًا وَاحْتِسَابًا غُفِرَ لَهُ مَا تَقَدَّمَ مِنْ ذَنْبِهِ",
     transliteration: "Man sama ramadana imanan wahtisaban ghufira lahu ma taqaddama min dhanbih",
     translation: "Whoever fasts Ramadan with faith and seeking reward, his past sins will be forgiven.",
     source: "Sahih Bukhari 38",
     theme: 'salvation'
   },
   {
     day: 29,
     arabic: "إِنَّ لِلصَّائِمِ فَرْحَتَيْنِ: فَرْحَةٌ عِنْدَ فِطْرِهِ وَفَرْحَةٌ عِنْدَ لِقَاءِ رَبِّهِ",
     transliteration: "Inna lis-sa'imi farhatayn: farhatun 'inda fitrihi wa farhatun 'inda liqa'i rabbih",
     translation: "The fasting person has two joys: joy when breaking fast, and joy when meeting his Lord.",
     source: "Sahih Bukhari 1904",
     theme: 'salvation'
   },
   {
     day: 30,
     arabic: "الصِّيَامُ وَالْقُرْآنُ يَشْفَعَانِ لِلْعَبْدِ يَوْمَ الْقِيَامَةِ",
     transliteration: "As-siyamu wal-Qur'anu yashfa'ani lil-'abdi yawmal-qiyamah",
     translation: "Fasting and the Quran will intercede for the servant on the Day of Resurrection.",
     source: "Musnad Ahmad 6626",
     theme: 'salvation'
   }
 ];
 
 export const getDayHadith = (day: number): DailyHadith | undefined => {
   return dailyHadiths.find(h => h.day === day);
 };